import { DefaultRootState } from "react-redux";

import { createSelector } from "@reduxjs/toolkit";

import { CatalogueState } from "@/store/reducers/catalogue";

export const getCatalogueData = createSelector(
  (state: DefaultRootState) => state.catalogue,
  ({ catalogue }: CatalogueState) => catalogue,
);

export const getTracksData = createSelector(
  (state: DefaultRootState) => state.catalogue,
  ({ tracks }: CatalogueState) => tracks,
);

export const getCatalogueFilters = createSelector(
  (state: DefaultRootState) => state.catalogue,
  ({ catalogueFilters }: CatalogueState) => catalogueFilters,
);

export const isLoadingCatalogue = createSelector(
  (state: DefaultRootState) => state.catalogue,
  ({ loading }: CatalogueState) => loading,
);

export const getAccumulatedTracks = createSelector(
  (state: DefaultRootState) => state.catalogue,
  ({ accumulatedTracks }: CatalogueState) => accumulatedTracks,
);
